import { AxiosInstance } from "axios";
import type {
  ClickUpFolder,
  ClickUpList,
  ClickUpSpace,
  ClickUpWorkspace,
} from "./ClickUpSourceSettings.types";

export class ClickUpSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getWorkspaces(
    boardId: string,
    connectionId: string,
  ): Promise<ClickUpWorkspace[]> {
    const response = await this.client.get<ClickUpWorkspace[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/clickup/workspaces`,
    );

    return response.data;
  }

  async getSpaces(
    boardId: string,
    connectionId: string,
    workspaceId: string,
  ): Promise<ClickUpSpace[]> {
    const response = await this.client.get<ClickUpSpace[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/clickup/workspaces/${encodeURIComponent(workspaceId)}/spaces`,
    );

    return response.data;
  }

  async getFolders(
    boardId: string,
    connectionId: string,
    spaceId: string,
  ): Promise<ClickUpFolder[]> {
    const response = await this.client.get<ClickUpFolder[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/clickup/spaces/${encodeURIComponent(spaceId)}/folders`,
    );

    return response.data;
  }

  async getLists(
    boardId: string,
    connectionId: string,
    spaceId: string,
  ): Promise<ClickUpList[]> {
    const response = await this.client.get<ClickUpList[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/clickup/spaces/${encodeURIComponent(spaceId)}/lists`,
    );

    return response.data;
  }

  async getList(
    boardId: string,
    connectionId: string,
    listId: string,
  ): Promise<ClickUpList> {
    const response = await this.client.get<ClickUpList>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/clickup/lists/${encodeURIComponent(listId)}`,
    );

    return response.data;
  }
}
